import { opaccAjaxPlugin } from '../opacc.static.js';
import { OpaccBasket } from './opacc.class.basket.js';

/** @module basket */

/**
 * MiniBasket funktionalität
 *
 * @extends {OpaccBasket}
 */
export class OpaccBasketInfo extends OpaccBasket {
	constructor() {
		super();
		if (this.miniBasket) {
			let basketItemsQuantitySelector = this.basketInfo.querySelector('.basket-info-count');
			let basketItemsQuantity = null;
			if (basketItemsQuantitySelector) {
				basketItemsQuantity = +basketItemsQuantitySelector.innerHTML;
			}
			if (basketItemsQuantity && this.miniBasketList.childElementCount === 0) {

                let url = opaccAjaxPlugin.setAsyncUrl(false);
				let request = this.basketInfo.dataset.opRequest;
				let data = {
					type: 'basket',
					action: 'items',
					template: this.basketAsyncTemplate,
					request: request
				};
				if (!this.basketOverview) {
					opaccAjaxPlugin.fetchAsynPostForm(url, data, this.updateItemsOnly.bind(this), this.asyncErrorHandler.bind(this), true);
				}
			}

			this.attachEventListener();
		}
	}

	/**
	 *
	 *
	 * @param {*} [status=null]
	 */
	// eslint-disable-next-line no-unused-vars
	toggleMiniBasket(status = null) {
		this.miniBasket.classList.toggle('is-open');
	}

	/**
	 *
	 *
	 * @param {*} item
	 * @param {*} response
	 */
	refreshResultList(item, response) {
		if (response.success) {
			this.updateMiniBasket(response.dataAsJson);
			this.updateBasket(item, response.dataAsJson);
		}
	}

	/**
	 *
	 *
	 * @param {*} basket
	 * @param {*} item
	 */
	deleteBasketItem(basket, item) {
		item.dataset.opAsynctemplate = this.basketAsyncTemplate;
		this.sendAjaxRequest(item);
		basket.removeChild(item.parentNode.parentNode);
	}

	/**
	 *
	 *
	 * @param {*} response
	 */
	updateItemsOnly(response) {
		if (response.success) {
			this.miniBasketList.innerHTML = response.dataAsJson.updateItemsOnly;
		}
	}

	/**
	 *
	 *
	 */
	attachEventListener() {
		if (this.basketInfo) {
			document.addEventListener('click', e => {
				if (e.target.closest(`.${this.basketInfo.className} ${this.basketInfoButtonSelector}`)) {
					if (this.offCanvasNaviElement) {
						// Redirect miniBasket to basket if mobile-navigation is shown
						this.redirectMiniBasket = window.getComputedStyle(this.offCanvasNaviElement).getPropertyValue('display') === 'none' ? false : true;
					}
					if (!this.redirectMiniBasket) {
						this.toggleMiniBasket('is-open');
					} else {
						window.location.href = this.redirectMiniBasketLink;
					}

				} else if (e.target.closest(`.${this.basketInfo.className}`) === null) {
					let emptyBasket = true;
					let eventPath = this.eventPath(e);
					eventPath.some(path => {
						if (path == this.basketInfo && this.miniBasketList.childElementCount > 0) {
							return emptyBasket = false;
						}
					});

					if (emptyBasket && this.miniBasket.classList.contains('is-open')) {
						this.toggleMiniBasket();
					}
				}
			}, false);
		}

		if (this.miniBasketList) {
			this.miniBasketList.addEventListener('click', e => {
				let delButtonSelector = '.basket-item-actions [data-op-btnaction="delete"]';
				if (e.target.closest(delButtonSelector) == null) {
					return;
				}

				let items = e.currentTarget.querySelectorAll(delButtonSelector);

				this.toggleButtonState(Array.from(items).filter(basketItem => basketItem != e.target.closest(delButtonSelector)), 'none');
				Array.from(items).forEach( item => {
					if (e.target.closest(delButtonSelector) == item){
						item.classList.add('is-progress');
						this.deleteBasketItem(e.currentTarget, item);
					}
				});
			}, false);
		}
	}
}